<template>
  <div class="login">
    <div class="message" v-if="message">{{message}}</div>
    <h1>Login</h1>
    <button @click="socialLogin">Login</button>
  </div>
</template>

<script>
import firebase from "firebase";
export default {
  name: "login",
  components: {},
  computed: {
    message () {
      return this.$store.getters.flashMessage || null;
    }
  },
  methods: {
    socialLogin() {
      const provider = new firebase.auth.GoogleAuthProvider();

      firebase
        .auth()
        .signInWithPopup(provider)
        .then(results => {
          this.$router.replace("home");
          let user = results.user
          console.log(user)
          user.lastName = results.additionalUserInfo.profile.family_name
          user.firstName = results.additionalUserInfo.profile.given_name
          this.$store.dispatch("syncUserDataWithLoginData", user);
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="scss"></style>